<template>
  <el-dialog
    title="新增下架产品通知"
    :visible.sync="dialogVisible"
    width="800"
    class="add-product"
    >
    <div class="form-item f">
      <div class="name">{{ productType === 'sku'?'SKU:':'SPU:' }}</div>
      <el-input style="width:500px" rows="4" type="textarea" v-model="spuCode" :placeholder="productType === 'sku'?'请输入SKU':'请输入SPU'"></el-input>
    </div>
    <div class="form-item f">
      <div class="name">发送日期:</div>
      <el-date-picker
        v-model="sendTime"
        type="datetime"
        placeholder="选择日期"
        :picker-options="dateOption">
      </el-date-picker>
      <div style="line-height:40px;margin-left:10px;color:#bbb">未选择发送日期则默认创建成功后立即发送</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="reset">取 消</el-button>
      <el-button type="primary" @click="affirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
export default {
  data() {
    return {
      dialogVisible: false,
      sendTime: undefined,
      spuCode: undefined,
      dateOption: {
        disabledDate(time) {
					return time.getTime() < (Date.now() - 3600 * 1000 * 24)   //time是禁用时间
				}
      },
      productType: 'spu'
    }
  },
  created() {
  },
  methods: {
    show(productType) {
      this.dialogVisible = true
      this.productType = productType
    },
    reset() {
      this.sendTime = undefined,
      this.spuCode = undefined
      this.dialogVisible = false
    },
    affirm() {
      if(!this.spuCode) {
        this.$message.error(this.productType === 'sku'?'请输入SKU':'请输入SPU')
        return
      }
      let separator = /,|\n/
      let spuCodes = this.spuCode.split(separator).filter(item => !!item)
      if (spuCodes.length>500) {
        this.$message.error(`输入的${this.productType === 'sku'?'SKU':'SPU'}数量须在500以内`)
      }
      const param = {
        sendTime:this.sendTime ? this.sendTime.valueOf() : new Date().getTime(),
      }
      param[this.productType === 'sku'?'skuCodes':'spuCodes'] = spuCodes
      let check = _.cloneDeep(param)
      delete check.sendTime
      API.productCheckSpuOrSku(check).then(res => {
        if (res.data.length === 0) {
          this.editProductTakeDown(param)
          return
        }
        this.$confirm(res.data.join('，')+` ${this.productType === 'sku'?'SKU':'SPU'}无效，确定要创建么`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.editProductTakeDown(param)
        })
      })
    },
    editProductTakeDown(param) {
      API.editProductTakeDown(param).then(() => {
        this.reset()
        this.$emit('success')
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .form-item{
  margin-bottom: 20px;
  .name{
    width: 100px;
    text-align: right;
    padding-right: 20px;
    line-height: 40px;
  }
}
</style>
